<!-- DYNAMIC LAYOUT FLEX CONTAINER -->
<div v-if="formConfig && formConfig.layout" class="flex flex-wrap -mx-2">

    <!-- {{ formData }} -->

    <div class="flex w-full">
        <!-- ALERT NOTIFICATION BANNERS -->
        <div v-if="errorMessage || successMessage" class="w-full px-2 mb-3">
            <div v-if="alert_type == 'classic' && errorMessage" class="p-3 text-sm rounded-md bg-rose-500/10 border border-rose-500/30 text-rose-600 dark:text-rose-400 flex items-center justify-between">
                <span>{{ errorMessage }}</span>
                <button type="button" @click="errorMessage = ''" class="text-xs font-bold hover:opacity-75">✕</button>
            </div>
            <div v-if="successMessage" class="p-3 text-sm rounded-md bg-emerald-500/10 border border-emerald-500/30 text-emerald-600 dark:text-emerald-400 flex items-center justify-between">
                <span>{{ successMessage }}</span>
                <button type="button" @click="successMessage = ''" class="text-xs font-bold hover:opacity-75">✕</button>
            </div>
        </div>
    </div>
    
    <!-- <div v-if="formConfig.logo" class="flex w-full justify-center">
        <img
            :src        = "formConfig.logo"
            class       = "w-1/2 px-3 py-2.5 text-sm mb-3.5"
        />
    </div> -->

    <template v-for="(section, idx) in formConfig.layout" :key="'sec-'+idx">
        <div v-if="section" :style="getSectionWidthStyle(section)" class="px-2 mb-4">
            
            <!-- 1. STYLE: CARD -->
            <component 
                :is="section.isform ? 'form' : 'div'" 
                v-if="section.style === 'card'" 
                ref             = "formRef"
                @submit.prevent = "handleFormSubmit($event, section)"
                class           = "border border-slate-200 dark:border-slate-800 rounded-md p-3 bg-white dark:bg-slate-800/60 shadow-sm flex flex-col"
            >
                <div :class="section.logo ? 'flex flex-row gap-4 justify-center' : 'flex flex-row gap-4'">
                    <h2 v-if="section.title" class="text-sm font-semibold text-slate-700 dark:text-slate-200 pb-2 mb-3 border-b border-slate-200 dark:border-slate-700">
                        {{ section.title }}
                    </h2>

                    <div v-if="section.logo">
                        <img
                            :id         = "section.id"
                            :src        = "section.logo"
                            class       = "w-full px-3 py-2.5 text-sm mb-3.5"
                        />
                    </div>

                    <div v-if="section.type === 'paint'">
                        <div :style="getGridStyle(section)">
                            <div v-for="field in section.input" 
                                :key    = "field.id" 
                                class   = "flex flex-col justify-start">
                                <template v-if="field.button">
                                    <button 
                                        :type       = "field.button === 'submit' ? 'submit' : 'button'"
                                        @click      = "handleButtonClick(field)"
                                        :disabled   = "isLoading"
                                        :class      = "[
                                            'w-full py-1.5 px-3 rounded text-sm font-medium transition-colors disabled:opacity-50 cursor-pointer',
                                            field.button === 'reset' ? 'bg-slate-200 dark:bg-slate-700 text-slate-800 dark:text-white' : 'bg-indigo-600 text-white hover:bg-indigo-500'
                                        ]">
                                        {{ parseFieldConfig(field.id).label }}
                                    </button>
                                </template>
    
                                <template v-else>
                                    <input 
                                        :type       = "field.type || 'text'"
                                        v-model     = "formData[parseFieldConfig(field.id).key]"
                                        :placeholder= "parseFieldConfig(field.id).placeholder"
                                        :required   = "field.required"
                                        class       = "w-full px-2.5 py-1.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500"
                                    />
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Sub-Layout Array Case -->
                <template v-if="section.layout && section.layout.length">
                    <div v-for="(subGroup, sIdx) in section.layout" :key="'sub-'+sIdx" class="mb-4 last:mb-0">
                        <h3 v-if="subGroup.title" class="text-xs font-semibold text-indigo-600 dark:text-indigo-400 mb-2 border-b border-slate-200 dark:border-slate-700">
                            {{ subGroup.title }}
                        </h3>
                        <div :style="getGridStyle(subGroup)">
                            <div v-for="field in subGroup.input" :key="field.id" class="flex flex-col justify-end">
                                <template v-if="field.button && !field.type">
                                    <button 
                                        :type       = "field.button === 'submit' ? 'submit' : 'button'"
                                        @click      = "handleButtonClick(field)"
                                        :disabled   = "isLoading"
                                        :class      = "[
                                                        'w-full py-2.5 px-3 rounded text-sm font-medium transition-colors disabled:opacity-50 cursor-pointer',
                                                        field.button === 'reset' ? 'bg-slate-200 dark:bg-slate-700 text-slate-800 dark:text-white' : 'bg-indigo-600 text-white hover:bg-indigo-500'
                                                    ]"
                                    >
                                        {{ parseFieldConfig(field.id).label }}
                                    </button>
                                </template>

                                <template v-else>
                                    <div class="relative w-full mb-2">
                                        <!-- SELECT FIELD -->
                                        <template v-if="field.type === 'select'">
                                            <select
                                                :id         = "field.id"
                                                v-model     = "formData[parseFieldConfig(field.id).key]"
                                                :required   = "field.required"
                                                class       = "peer w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                            >
                                                <option value="" disabled hidden></option>
                                                <option v-for="opt in field.options" :key="opt" :value="opt">{{ opt }}</option>
                                            </select>
                                        </template>

                                        <!-- VUE SELECT FIELD -->
                                        <template v-if="field.type === 'vueSelect'">
                                            <VueSelect 
                                                v-model  = "formData[parseFieldConfig(field.id).key]" 
                                                :label   = "field.label"
                                                :options = "field.options"
                                            />
                                        </template>

                                        <!-- FLATPICKR DATE FIELD -->
                                        <template v-else-if="field.type === 'date'">
                                            <flat-pickr
                                                :id         = "field.id"
                                                :model-value= "formData[parseFieldConfig(field.id).key] ?? null"
                                                @update:model-value = "val => formData[parseFieldConfig(field.id).key] = val"
                                                :config     = "field.config === 'single' ? DateSingle : DateRange"
                                                placeholder = " "
                                                :required   = "field.required"
                                                class       = "peer w-full px-3 py-2.5 text-sm 
                                                                rounded border border-slate-300 dark:border-slate-700 
                                                                bg-white dark:bg-slate-800 text-slate-900 
                                                                dark:text-white focus:ring-2 focus:ring-indigo-500 
                                                                focus:outline-none cursor-pointer transition-all"
                                            />
                                        </template>

                                        <!-- STANDARD INPUT FIELD -->
                                        <template v-else-if="field.type === 'input'">
                                            <input
                                                :type       = "field.type || 'text'"
                                                :id         = "field.id"
                                                v-model     = "formData[parseFieldConfig(field.id).key]"
                                                placeholder = " "
                                                spellcheck="false"
                                                :required   = "field.required"
                                                class       = "peer w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                            />
                                        </template>

                                        <!-- Image -->
                                        <template v-else-if="field.type === 'image'">
                                                <img
                                                    :id         = "field.id"
                                                    :src        = "field.src"
                                                    class       = "w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                                />
                                        </template>
                                        
                                        <!-- Video Stream -->
                                        <template v-else-if="field.type === 'video'">
                                            <template v-if="field.textfield">
                                                <input
                                                    type       = "text"
                                                    :id         = "field.id"
                                                    v-model     = "formData[parseFieldConfig(field.id).key]"
                                                    placeholder = " "
                                                    spellcheck="false"
                                                    :required   = "field.required"
                                                    class       = "peer w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                                />
                                            </template>
                                            <div class="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap">
                                                <div v-for="player_button in field.buttonVideo" class="flex-1">
                                                    <template v-if="player_button.text" :key="`${formData[parseFieldConfig(field.id).key]}-${player_button.id}`">
                                                        <!-- {{ player_button.handle }} -->
                                                        <button 
                                                            type        ="button"
                                                            @click      ="handleButtonClick(player_button)"
                                                            :disabled   ="isLoading"
                                                            :style      ="{ backgroundColor: player_button.bg_color || 'blue'}"
                                                            class       ="w-full py-2 mt-2 mb-2 rounded-sm text-sm font-medium 
                                                                        transition-colors disabled:opacity-50 cursor-pointer 
                                                                        text-white hover:brightness-110">
                                                            {{ player_button.text }}
                                                        </button>
                                                    </template>
                                                </div>
                                            </div>

                                            <video  
                                                :id="field.id"
                                                :src="linkVideo[parseFieldConfig(field.id).key] ?? field.defVideo" 
                                                controls 
                                                class="w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                                autoplay
                                                muted
                                                loop
                                                crossorigin="anonymous"
                                            ></video>
                                        </template>

                                        <!-- Chart -->
                                        <template v-else-if="field.type === 'chart'">
                                            <!-- {{ rawMetrics[parseFieldConfig(field.id).key].chartOptions }} -->
                                            <!-- {{ rawMetrics }} -->
                                            <div v-if="rawMetrics[parseFieldConfig(field.id).key]">
                                                <VueApexCharts
                                                    :id         ="field.id"
                                                    :height     ="field.height"
                                                    :type       ="field.chartType === 'doughnut' ? 'donut' : field.chartType"
                                                    :options    ="rawMetrics[parseFieldConfig(field.id).key].chartOptions"
                                                    :series     ="rawMetrics[parseFieldConfig(field.id).key].series"
                                                    width       ="100%"
                                                    class       ="rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                                />
                                            </div>
                                            <div v-else>
                                                <p>Loading chart data...</p>
                                            </div>
                                        </template>

                                        <!-- Editor -->
                                        <template v-else-if="field.type === 'editor'">
                                            <Editor 
                                                editorStyle  = "height: 320px" 
                                                @load        = "({ instance }) => instance.root.setAttribute('id', field.id)"
                                                @text-change = "handleTextChange"
                                            />
                                        </template>

                                        <!-- Text Area -->
                                        <template v-else-if="field.type === 'textarea'">
                                            <textarea 
                                                :id         = "field.id"
                                                placeholder = " " 
                                                :rows       = "field.rows" 
                                                class       = "dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"></textarea>
                                        </template>
                                                                                
                                        <!-- Map -->
                                        <template v-else-if="field.type === 'map'">
                                            <div style="height: 600px; width: 100%;position: sticky;">
                                                <l-map 
                                                    :id="field.id"
                                                    ref="map" 
                                                    v-model:zoom="field.zoom" 
                                                    :center="field.center"
                                                >
                                                    <l-tile-layer
                                                        :url="field.url"
                                                        :layer-type="field.layer"
                                                        name="OpenStreetMap"
                                                    ></l-tile-layer>
                                                    
                                                    <l-marker 
                                                        v-for="item in mapMarkers"
                                                        :lat-lng="[item.lat, item.long]"
                                                    >
                                                        <!-- Icon khusus untuk setiap marker -->
                                                        <l-icon
                                                            :icon-url="field.icon"
                                                            :icon-size="[40, 40]"
                                                            :icon-anchor="[20, 20]"
                                                        />

                                                        <!-- Optional: Popup saat marker diklik -->
                                                        <!-- <LPopup v-if="item.title">
                                                        {{ item.title }}
                                                        </LPopup> -->
                                                    </l-marker>
                                                </l-map>
                                            </div>
                                        </template>

                                        <template v-else>
                                            <input
                                                :type       = "field.type || 'text'"
                                                :id         = "field.id"
                                                v-model     = "formData[parseFieldConfig(field.id).key]"
                                                placeholder = " "
                                                spellcheck="false"
                                                :required   = "field.required"
                                                class       = "peer w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                            />
                                        </template>

                                        <!-- LARGER FLOATING LABEL -->
                                         <div v-if="field.type !== 'chart' ">
                                             <label 
                                                 :for="field.id"
                                                 class="absolute text-md text-slate-500 dark:text-slate-400 duration-200 
                                                         transform scale-85 -top-3 left-2.5 z-10 origin-left px-1 
                                                         bg-white dark:bg-slate-800 
                                                         peer-placeholder-shown:scale-78 
                                                         peer-placeholder-shown:top-2.5 
                                                         peer-placeholder-shown:bg-transparent 
                                                         peer-focus:text-indigo-600 
                                                         dark:peer-focus:text-indigo-400 
                                                         peer-focus:scale-90 font-bold
                                                         peer-focus:-top-3 
                                                         peer-focus:bg-white 
                                                         dark:peer-focus:bg-slate-800 
                                                         whitespace-nowrap truncate max-w-[calc(100%-12px)]
                                                         pointer-events-none"
                                             >
                                                 {{ parseFieldConfig(field.id).label }} <span v-if="field.required" class="text-rose-500">*</span>
                                             </label>
                                         </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>

                <!-- Special for Calendar -->
                <template v-else-if="section.type === 'calendar'">
                    <FullCalendar :options='calendarOptions'>
                        <template v-slot:eventContent='arg'>
                            <b>{{ arg.timeText }}</b>
                            <i>{{ arg.event.title }}</i>
                        </template>
                    </FullCalendar>
                </template>
                
                <!-- Special for Map -->
                 <template v-else-if="section.type === 'map'">
                    <div style="height: 600px; width: 100%;position: sticky;">
                        <l-map 
                            :id="section.id"
                            ref="map" 
                            v-model:zoom="section.zoom" 
                            :center="section.center"
                        >
                            <l-tile-layer
                                :url="section.url"
                                :layer-type="section.layer"
                                name="OpenStreetMap"
                            ></l-tile-layer>
                            
                            <l-marker 
                                v-for="item in mapMarkers"
                                :lat-lng="[item.lat, item.long]"
                            >
                                <!-- Icon khusus untuk setiap marker -->
                                <l-icon
                                    :icon-url="section.icon"
                                    :icon-size="[40, 40]"
                                    :icon-anchor="[20, 20]"
                                />

                                <!-- Optional: Popup saat marker diklik -->
                                <!-- <LPopup v-if="item.title">
                                {{ item.title }}
                                </LPopup> -->
                            </l-marker>
                        </l-map>
                    </div>
                </template>

                <!-- Special for Paint -->
                <template v-else-if="section.type === 'paint'">
                    <div class="wrapper mt-2.5">

                        <video 
                            ref="videoRef" 
                            :src="urlVideo" 
                            controls 
                            style="width: 100%; height: 50vh;"
                            autoplay
                            muted
                            loop
                            crossorigin="anonymous"
                        ></video>

                        <!-- Trigger Button -->
                        <button 
                            @click="captureFrame"
                            class="w-full mt-2 py-1.5 px-3 mb-3 rounded text-sm font-medium transition-colors disabled:opacity-50 cursor-pointer bg-indigo-600 text-white hover:bg-indigo-500"
                        > 
                            Capture Image
                        </button>

                        <!-- Hidden Canvas used for processing -->
                        <canvas ref="canvasRef" style="display: none;"></canvas>

                    </div>
                    <vp-editor :key="editorKey" v-model:history="history" v-model:settings="settings" @save="$emit('save', $event)" :tools>
                        <template #toolbar="{ setTool, undo, redo, save, reset }">
                            <vp-toolbar v-model:settings="settings" @set-tool="setTool" @undo="undo" @redo="redo" @save="save" @reset="reset"
                                :tools class="text-4xl flex flex-row justify-between mt-1">

                                <template v-if="showPalette">
                                    <div class="palette">
                                        <button v-for="color in palette" :key="color" @click="setColor(color)">
                                            <div class="color mr-1" :style="`background: ${color};`"></div>
                                        </button>
                                    </div>
                                </template>

                                <template #setting-color>
                                    <button @click="showPalette = true">
                                        <div class="color" :style="{ background: settings.color }"></div>
                                    </button>
                                </template>

                            </vp-toolbar>
                        </template>
                    </vp-editor>
                </template>

                <!-- Special for Preview Summary All Employees -->
                <template v-else-if="section.type === 'tableExport'">
                    <div class="overflow-x-auto">
                        <table border="1" class="border-collapse border border-slate-800 w-full text-sm">
                            <thead>
                                <!-- First Header Row -->
                                <tr class="bg-slate-800">
                                    <th rowspan="2" class="border px-2 py-1 w-12 text-center">No</th>
                                    <th rowspan="2" class="sticky left-0 z-20 bg-slate-100 dark:bg-slate-800 border p-2 min-w-12.5">Nama Karyawan</th>
                                    <!-- <th rowspan="2" class="border px-2 py-1 min-w-50 text-center">Nama Karyawan</th> -->
                                    <th rowspan="2" class="border px-2 py-1 min-w-37.5 text-center">Departemen</th>

                                    <!-- Group Header Date -->
                                    <th 
                                        v-for="tgl in section.tanggal" 
                                        :key="tgl" 
                                        colspan="4" 
                                        class="border px-2 py-1 text-center whitespace-nowrap min-w-[320px]"
                                    >
                                        {{ `${moment(tgl).format('dddd')}, ${moment(tgl).format('DD MMM YYYY')}` }}
                                    </th>

                                    <!-- Summary Header -->
                                    <th rowspan="2" class="border px-2 py-1 text-center">Jumlah Kehadiran</th>
                                    <th rowspan="2" class="border px-2 py-1 text-center">Jumlah Terlambat</th>
                                    <th rowspan="2" class="border px-2 py-1 text-center">Jumlah Jam Kerja</th>
                                    <th rowspan="2" class="border px-2 py-1 text-center">Jumlah Jam Terlambat</th>
                                    <th rowspan="2" class="border px-2 py-1 text-center">Jumlah Jam Lembur</th>
                                </tr>

                                <!-- Second Header Row -->
                                <tr class="bg-slate-800">
                                    <template v-for="tgl in section.tanggal" :key="'sub-' + tgl">
                                        <th class="border px-1 py-1 w-20 text-center">IN</th>
                                        <th class="border px-1 py-1 w-20 text-center">LT</th>
                                        <th class="border px-1 py-1 w-20 text-center">OUT</th>
                                        <th class="border px-1 py-1 w-20 text-center">OVT</th>
                                    </template>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(d, i) in section.reportData" :key="d.id || i" class="hover:bg-slate-600">
                                    <td class="border px-2 py-1 text-center">{{ i + 1 }}</td>
                                    <td class="sticky left-0 z-20 bg-slate-100 dark:bg-slate-800 border p-2 min-w-50">{{ d.fullname }}</td>
                                    <td class="border px-2 py-1 text-center">{{ d.group }}</td>

                                    <!-- Attendance data each date -->
                                    <template v-for="(tgl, idx) in d.tanggalData" :key="idx">
                                        <!-- If Alias exists (Leave / Sick) -->
                                        <td 
                                        v-if="tgl.alias" 
                                        colspan="4" 
                                        class="border px-2 py-1 text-center font-bold text-lg"
                                        >
                                            {{ tgl.alias }}
                                        </td>

                                        <!-- If Normal (IN, LT, OUT, OVT) -->
                                        <template v-else>
                                            <td class="border px-1 py-1 text-center">{{ tgl.in || '-' }}</td>
                                            <td class="border px-1 py-1 text-center">{{ tgl.late || '-' }}</td>
                                            <td class="border px-1 py-1 text-center">{{ tgl.out || '-' }}</td>
                                            <td class="border px-1 py-1 text-center">{{ tgl.ovt || '-' }}</td>
                                        </template>
                                    </template>

                                    <!-- Summary Data -->
                                    <td class="border px-2 py-1 text-center">{{ d.hariKerja }}</td>
                                    <td class="border px-2 py-1 text-center">{{ d.hariTelat }}</td>
                                    <td class="border px-2 py-1 min-w-30 text-center">{{ d.durasiKerja }}</td>
                                    <td class="border px-2 py-1 min-w-30 text-center">{{ d.durasiTelat }}</td>
                                    <td class="border px-2 py-1 min-w-30 text-center">{{ d.durasiLembur }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>

                <!-- Special for Preview Summary one Employees -->
                <template v-else-if="section.type === 'tableExportPerson'">
                    <div class="overflow-x-auto">
                        <table class="w-full text-sm mb-4">
                            <tbody>
                                <tr>
                                    <td class="px-2 w-40 text-left font-bold">Nama Karyawan</td>
                                    <td class="max-w-1 text-center">:</td>
                                    <td class="px-2 py-1 text-left">{{ section.fullname }}</td>
                                </tr>
                                <tr>
                                    <td class="px-2 w-40 text-left font-bold">Periode</td>
                                    <td class="max-w-1 text-center">:</td>
                                    <td class="px-2 py-1 text-left">{{ section.periode }}</td>
                                </tr>
                                <tr>
                                    <td class="px-2 w-40 text-left font-bold">Total Jam Kerja</td>
                                    <td class="max-w-1 text-center">:</td>
                                    <td class="px-2 py-1 text-left">{{ section.totalKerja }}</td>
                                </tr>
                                <tr>
                                    <td class="px-2 w-40 text-left font-bold">Total Jam Terlambat</td>
                                    <td class="max-w-1 text-center">:</td>
                                    <td class="px-2 py-1 text-left">{{ section.totalTelat }}</td>
                                </tr>
                                <tr>
                                    <td class="px-2 w-40 text-left font-bold">Total Jam Lembur</td>
                                    <td class="max-w-1 text-center">:</td>
                                    <td class="px-2 py-1 text-left">{{ section.totalLembur }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <table border="1" class="border-collapse border border-slate-800 w-full text-sm">
                            <thead>
                                <tr class="bg-slate-800 text-white">
                                    <th class="border border-slate-700 px-3 py-2 text-center">Tanggal</th>
                                    <th class="border border-slate-700 px-3 py-2 text-center">Jam datang</th>
                                    <th class="border border-slate-700 px-3 py-2 text-center">Jam pulang</th>
                                    <th class="border border-slate-700 px-3 py-2 text-center">Terlambat</th>
                                    <th class="border border-slate-700 px-3 py-2 text-center">Lembur</th>
                                    <th class="border border-slate-700 px-3 py-2 text-center">Keterangan</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, idx) in (section.reportData || [])" :key="idx" class="hover:bg-slate-700/50">
                                    <td class="border border-slate-700 px-3 py-1.5 text-center whitespace-nowrap">{{ item.formattedDate }}</td>
                                    <td class="border border-slate-700 px-3 py-1.5 text-center">{{ item.in_time }}</td>
                                    <td class="border border-slate-700 px-3 py-1.5 text-center">{{ item.out_time }}</td>
                                    <td class="border border-slate-700 px-3 py-1.5 text-center">{{ item.late_duration }}</td>
                                    <td class="border border-slate-700 px-3 py-1.5 text-center">{{ item.overtime_duration }}</td>
                                    <td class="border border-slate-700 px-3 py-1.5 text-center">{{ item.keterangan }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>

                <!-- Direct Input Array Case -->
                <template v-else-if="section.input && section.input.length">
                    <div :style="getGridStyle(section)">
                        <div v-for="field in section.input" :key="field.id" class="flex flex-col justify-start">
                            <template v-if="field.button">
                                <button 
                                    :type       = "field.button === 'submit' ? 'submit' : 'button'"
                                    @click      = "handleButtonClick(field)"
                                    :disabled   = "isLoading"
                                    :class      = "[
                                                    'w-full py-2.5 px-3 rounded text-sm font-medium transition-colors disabled:opacity-50 cursor-pointer',
                                                    field.button === 'reset' ? 'bg-slate-200 dark:bg-slate-700 text-slate-800 dark:text-white' : 'bg-indigo-600 text-white hover:bg-indigo-500'
                                                ]"
                                >
                                    {{ parseFieldConfig(field.id).label }}
                                </button>
                            </template>

                            <!-- USUALY THIS IS FILTER FIELDS  -->
                            <template v-else>
                                <div class="relative w-full mb-2">
                                    <template v-if="field.type === 'select'">
                                        <select
                                            :id         = "field.id"
                                            v-model     = "formData[parseFieldConfig(field.id).key]"
                                            :required   = "field.required"
                                            class       = "peer w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                        >
                                            <option value="" disabled hidden></option>
                                            <option v-for="opt in field.options" :key="opt" :value="opt">{{ opt }}</option>
                                        </select>
                                    </template>

                                    <template v-else-if="field.type === 'date'">
                                        <flat-pickr
                                            :id         = "field.id"
                                            v-model     = "formData[parseFieldConfig(field.id).key]"
                                            :config     = "field.config === 'single' ? DateSingle : DateRange"
                                            placeholder = " "
                                            :required   = "field.required"
                                            class       = "peer w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none cursor-pointer transition-all"
                                        />
                                    </template>

                                    <!-- Text Area -->
                                    <template v-else-if="field.type === 'textarea'">
                                        <textarea 
                                            :id         = "field.id"
                                            v-model     = "formData[parseFieldConfig(field.id).key]"
                                            placeholder = " " 
                                            :rows       = "field.rows" 
                                            class       = "dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800">
                                        </textarea>
                                        <!-- <button 
                                            type        ="button"
                                            @click      ="handleButtonClick(field.areaButton)"
                                            :disabled   ="isLoading"
                                            :style      ="{ backgroundColor: field.areaButton.bg_color || 'blue'}"
                                            class       ="w-full py-2 mt-2 mb-2 rounded-sm text-sm font-medium 
                                                        transition-colors disabled:opacity-50 cursor-pointer 
                                                        text-white hover:brightness-110">
                                            {{ field.areaButton.text }}
                                        </button> -->
                                    </template>
                                    
                                    <!-- Image -->
                                    <template v-else-if="field.type === 'image'">
                                            <img
                                                :id         = "field.id"
                                                :src        = "field.src"
                                                class       = "w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                            />
                                    </template>
                                    
                                    <!-- Video Stream -->
                                    <template v-else-if="field.type === 'video'">
                                        <template v-if="field.textfield">
                                            <input
                                                type       = "text"
                                                :id         = "field.id"
                                                v-model     = "formData[parseFieldConfig(field.id).key]"
                                                placeholder = " "
                                                spellcheck="false"
                                                :required   = "field.required"
                                                class       = "peer w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                            />
                                        </template>
                                        <div class="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap">
                                            <div v-for="player_button in field.buttonVideo" class="flex-1">
                                                <template v-if="player_button.text" :key="`${formData[parseFieldConfig(field.id).key]}-${player_button.id}`">
                                                    <!-- {{ player_button.handle }} -->
                                                    <button 
                                                        type        ="button"
                                                        @click      ="handleButtonClick(player_button)"
                                                        :disabled   ="isLoading"
                                                        :style      ="{ backgroundColor: player_button.bg_color || 'blue'}"
                                                        class       ="w-full py-2 mt-2 mb-2 rounded-sm text-sm font-medium 
                                                                    transition-colors disabled:opacity-50 cursor-pointer 
                                                                    text-white hover:brightness-110">
                                                        {{ player_button.text }}
                                                    </button>
                                                </template>
                                            </div>
                                        </div>

                                        <video  
                                            :id="field.id"
                                            :src="linkVideo[parseFieldConfig(field.id).key] ?? field.defVideo" 
                                            controls 
                                            class="w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                            autoplay
                                            muted
                                            loop
                                            crossorigin="anonymous"
                                        ></video>
                                    </template>

                                    <!-- Chart -->
                                    <template v-else-if="field.type === 'chart'">
                                        <!-- {{ rawMetrics[parseFieldConfig(field.id).key].chartOptions }} -->
                                        <!-- {{ rawMetrics }} -->
                                        <div v-if="rawMetrics[parseFieldConfig(field.id).key]">
                                            <VueApexCharts
                                                :id         ="field.id"
                                                :height     ="field.height"
                                                :type       ="field.chartType === 'doughnut' ? 'donut' : field.chartType"
                                                :options    ="rawMetrics[parseFieldConfig(field.id).key].chartOptions"
                                                :series     ="rawMetrics[parseFieldConfig(field.id).key].series"
                                                width       ="100%"
                                                class       ="rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                            />
                                        </div>
                                        <div v-else>
                                            <p>Loading chart data...</p>
                                        </div>
                                    </template>

                                    <!-- Editor -->
                                    <template v-else-if="field.type === 'editor'">
                                        <Editor 
                                            editorStyle  = "height: 320px"
                                            v-model      = "formData[parseFieldConfig(field.id).key]"
                                            @load        = "({ instance }) => instance.root.setAttribute('id', field.id)"
                                        />
                                    </template>
                                                                            
                                    <!-- Map -->
                                    <template v-else-if="field.type === 'map'">
                                        <div style="height: 600px; width: 100%;position: sticky;">
                                            <l-map 
                                                :id="field.id"
                                                ref="map" 
                                                v-model:zoom="field.zoom" 
                                                :center="field.center"
                                            >
                                                <l-tile-layer
                                                    :url="field.url"
                                                    :layer-type="field.layer"
                                                    name="OpenStreetMap"
                                                ></l-tile-layer>
                                                
                                                <l-marker 
                                                    v-for="item in mapMarkers"
                                                    :lat-lng="[item.lat, item.long]"
                                                >
                                                    <!-- Icon khusus untuk setiap marker -->
                                                    <l-icon
                                                        :icon-url="field.icon"
                                                        :icon-size="[40, 40]"
                                                        :icon-anchor="[20, 20]"
                                                    />

                                                    <!-- Optional: Popup saat marker diklik -->
                                                    <!-- <LPopup v-if="item.title">
                                                    {{ item.title }}
                                                    </LPopup> -->
                                                </l-marker>
                                            </l-map>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <input
                                            :id         = "field.id"
                                            v-model     = "formData[parseFieldConfig(field.id).key]"
                                            :type       = "field.type || 'text'"
                                            placeholder = " "
                                            spellcheck="false"
                                            :required   = "field.required"
                                            class       = "peer w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                        />                
                                    </template>

                                    <label 
                                        :for    = "field.id"
                                        class   = "absolute text-md text-slate-500 dark:text-slate-400 duration-200 
                                                    transform scale-85 -top-3 left-2.5 z-10 origin-left px-1 
                                                    bg-white dark:bg-slate-800 
                                                    peer-placeholder-shown:scale-78 
                                                    peer-placeholder-shown:top-2.5 
                                                    peer-placeholder-shown:bg-transparent 
                                                    peer-focus:text-indigo-600 
                                                    dark:peer-focus:text-indigo-400 
                                                    peer-focus:scale-90 font-bold
                                                    peer-focus:-top-3 
                                                    peer-focus:bg-white 
                                                    dark:peer-focus:bg-slate-800 
                                                    whitespace-nowrap truncate max-w-[calc(100%-12px)]
                                                    pointer-events-none"
                                    >
                                        {{ parseFieldConfig(field.id).label }} <span v-if="field.required" class="text-rose-500">*</span>
                                    </label>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
            </component>

            <!-- 2. STYLE: GRID -->
            <div v-else-if="section.style === 'grid'" class="w-full rounded-sm shadow-md border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-800 flex flex-col h-130 relative">
                <div v-if="isLoading || directLoading" class="absolute inset-0 z-50 flex items-center justify-center bg-white/50 dark:bg-slate-900/50">
                    <Vue3Lottie :animationData="lottieLoading" height="30vh" width="30vw" />
                </div>
                <div class="w-full grow overflow-hidden" :class="{ 'blur-xs pointer-events-none opacity-50': isLoading }">
                    <ag-grid-vue
                            :id                         = "section.id"
                            class                       = "w-full h-full"
                            :columnDefs                 = "columnDefs.length ? columnDefs : directColumn"
                            :rowData                    = "rowData.length ? rowData : directRow"
                            :defaultColDef              = "defaultColDef"
                            :theme                      = "AgGridDark"
                            :pagination                 = "true"
                            :paginationPageSize         = "paginationPageSize"
                            :paginationPageSizeSelector = "paginationPageSizeSelector"
                            :animateRows                = "true"
                            @row-double-clicked         = "onRowDoubleClicked"
                            @row-clicked                = "onRowSingleClicked"
                    />
                </div>
            </div>

            <!-- 3. STYLE: TAB -->
            <component 
                :is="section.isform ? 'form' : 'div'" 
                v-else-if="section.style === 'tab'" 
                ref="formRef"
                @submit.prevent="handleFormSubmit($event, section)"
                class="border border-slate-200 dark:border-slate-800 rounded-md p-3 bg-white dark:bg-slate-800/60 shadow-sm"
            >
                <div v-if="section.layout && section.layout.length" class="flex border-b border-slate-200 dark:border-slate-700 mb-3">
                    <button
                        v-for="(tab, tIdx) in section.layout"
                        :key="'tab-head-'+tIdx"
                        type="button"
                        @click="activeTabIndex = tIdx"
                        :class="[
                            'px-4 py-2 text-sm font-medium border-b-2 transition-colors -mb-px cursor-pointer',
                            activeTabIndex === tIdx 
                                ? 'border-indigo-600 text-indigo-600 dark:text-indigo-400' 
                                : 'border-transparent text-slate-500 hover:text-slate-700 dark:text-slate-400'
                        ]"
                    >
                        {{ tab.title }}
                    </button>
                </div>

                <div v-for="(tab, tIdx) in section.layout" :key="'tab-body-'+tIdx" v-show="activeTabIndex === tIdx">
                    <div :style="getGridStyle(tab)">
                        <div v-for="field in tab.input" :key="field.id" 
                        :style="field.span ? { gridColumn: `span ${field.span} / span ${field.span}` } : {}"
                        :class="field.type == 'grid' ? `col-span-${field.span}` : `col-span-${field.span}`">
                            <template v-if="field.button">
                                <button 
                                    :type       = "field.button === 'submit' ? 'submit' : 'button'"
                                    @click      = "handleButtonClick(field)"
                                    :disabled   = "isLoading"
                                    :class      = "[
                                                    'w-full py-2.5 px-3 rounded text-sm font-medium transition-colors disabled:opacity-50 cursor-pointer',
                                                    field.button === 'reset' ? 'bg-slate-200 dark:bg-slate-700 text-slate-800 dark:text-white' : 'bg-indigo-600 text-white hover:bg-indigo-500'
                                                ]"
                                >
                                    {{ parseFieldConfig(field.id).label }}
                                </button>
                            </template>

                            <template v-else>
                                <div class="relative w-full mb-2">
                                    <template v-if="field.type === 'select'">
                                        <select
                                            :id         =   "field.id"
                                            v-model     =   "formData[parseFieldConfig(field.id).key]"
                                            :required   = "field.required"
                                            class       = "peer w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                        >
                                            <option value="" disabled hidden></option>
                                            <option v-for="opt in field.options" :key="parseFieldConfig(opt).key" :value="parseFieldConfig(opt).key">{{ parseFieldConfig(opt).label }}</option>
                                        </select>
                                    </template>

                                    <!-- VUE SELECT FIELD -->
                                    <template v-else-if="field.type === 'vueSelect'">
                                        <VueSelect
                                            v-model  = "formData[parseFieldConfig(field.id).key]" 
                                            :label   = "field.label"
                                            :options = "field.options"
                                        />
                                    </template>

                                    <!-- FLATPICKR DATE FIELD -->
                                    <template v-else-if="field.type === 'date'">
                                        <flat-pickr
                                            :id         = "field.id"
                                            :model-value= "formData[parseFieldConfig(field.id).key] ?? null"
                                            @update:model-value = "val => formData[parseFieldConfig(field.id).key] = val"
                                            :config     = "field.config === 'single' ? DateSingle : DateRange"
                                            placeholder = " "
                                            :required   = "field.required"
                                            class       = "peer w-full px-3 py-2.5 text-sm 
                                                            rounded border border-slate-300 dark:border-slate-700 
                                                            bg-white dark:bg-slate-800 text-slate-900 
                                                            dark:text-white focus:ring-2 focus:ring-indigo-500 
                                                            focus:outline-none cursor-pointer transition-all"
                                        />
                                    </template>

                                    <!-- FLATPICKR DATE TIME FIELD -->
                                    <template v-else-if="field.type === 'datetime'">
                                        <flat-pickr
                                            :id         = "field.id"
                                            :model-value= "formData[parseFieldConfig(field.id).key] ?? null"
                                            @update:model-value = "val => formData[parseFieldConfig(field.id).key] = val"
                                            :config     = "DateTime"
                                            placeholder = " "
                                            :required   = "field.required"
                                            class       = "peer w-full px-3 py-2.5 text-sm 
                                                            rounded border border-slate-300 dark:border-slate-700 
                                                            bg-white dark:bg-slate-800 text-slate-900 
                                                            dark:text-white focus:ring-2 focus:ring-indigo-500 
                                                            focus:outline-none cursor-pointer transition-all"
                                        />
                                    </template>

                                    <!-- FLATPICKR TIME FIELD -->
                                    <template v-else-if="field.type === 'time'">
                                        <flat-pickr
                                            :id         = "field.id"
                                            :model-value= "formData[parseFieldConfig(field.id).key] ?? null"
                                            @update:model-value = "val => formData[parseFieldConfig(field.id).key] = val"
                                            :config     = "TimePicker"
                                            placeholder = " "
                                            :required   = "field.required"
                                            class       = "peer w-full px-3 py-2.5 text-sm 
                                                            rounded border border-slate-300 dark:border-slate-700 
                                                            bg-white dark:bg-slate-800 text-slate-900 
                                                            dark:text-white focus:ring-2 focus:ring-indigo-500 
                                                            focus:outline-none cursor-pointer transition-all"
                                        />
                                    </template>

                                    <!-- STANDARD INPUT FIELD -->
                                    <template v-else-if="field.type === 'input'">
                                        <input
                                            :type       = "field.type || 'text'"
                                            :id         = "field.id"
                                            v-model     = "formData[parseFieldConfig(field.id).key]"
                                            placeholder = " "
                                            spellcheck="false"
                                            :required   = "field.required"
                                            class       = "peer w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                        />
                                    </template>

                                    <!-- STANDARD FILE INPUT FIELD -->
                                    <template v-else-if="field.type === 'file'">
                                        <input
                                            :id="field.id"
                                            type="file"
                                            :accept="field.accept"
                                            :multiple="field.multiple"
                                            :required="field.required"
                                            @change="(e) => formData[parseFieldConfig(field.id).key] = field.multiple ? Array.from(e.target.files) : e.target.files[0]"
                                            class="peer w-full px-3 py-2 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white file:mr-4 file:py-1.5 file:px-3 file:rounded file:border-0 file:text-xs file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 dark:file:bg-slate-700 dark:file:text-slate-200 focus:outline-none cursor-pointer transition-all"
                                        />
                                    </template>
                                    
                                    <!-- Dropzone -->
                                    <template v-else-if="field.type === 'dropzone'">
                                        <DropZone 
                                            :maxFiles       = "Number(field.fileConfig.maxFiles)"
                                            :url            = "field.fileConfig.url"
                                            :uploadOnDrop   = "field.fileConfig.uploadOnDrop"
                                            :multipleUpload = "field.fileConfig.multipleUpload"
                                            :parallelUpload = "field.fileConfig.parallelUpload"
                                        />
                                    </template>

                                    <!-- Image -->
                                    <template v-else-if="field.type === 'image'">
                                        <img
                                            :id         = "field.id"
                                            :src        = "field.src"
                                            class       = "w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                        />
                                    </template>
                                    
                                    <!-- Video Stream -->
                                    <template v-else-if="field.type === 'video'">
                                        <template v-if="field.textfield">
                                            <input
                                                type       = "text"
                                                :id         = "field.id"
                                                v-model     = "formData[parseFieldConfig(field.id).key]"
                                                placeholder = " "
                                                spellcheck="false"
                                                :required   = "field.required"
                                                class       = "peer w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                            />
                                        </template>
                                        <div class="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap">
                                            <div v-for="player_button in field.buttonVideo" class="flex-1">
                                                <template v-if="player_button.text" :key="`${formData[parseFieldConfig(field.id).key]}-${player_button.id}`">
                                                    <!-- {{ player_button.handle }} -->
                                                    <button 
                                                        type        ="button"
                                                        @click      ="handleButtonClick(player_button)"
                                                        :disabled   ="isLoading"
                                                        :style      ="{ backgroundColor: player_button.bg_color || 'blue'}"
                                                        class       ="w-full py-2 mt-2 mb-2 rounded-sm text-sm font-medium 
                                                                    transition-colors disabled:opacity-50 cursor-pointer 
                                                                    text-white hover:brightness-110">
                                                        {{ player_button.text }}
                                                    </button>
                                                </template>
                                            </div>
                                        </div>

                                        <video  
                                            :id="field.id"
                                            :src="linkVideo[parseFieldConfig(field.id).key] ?? field.defVideo" 
                                            controls 
                                            class="w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                            autoplay
                                            muted
                                            loop
                                            crossorigin="anonymous"
                                        ></video>
                                    </template>

                                    <!-- Chart -->
                                    <template v-else-if="field.type === 'chart'">
                                        <!-- {{ rawMetrics[parseFieldConfig(field.id).key].chartOptions }} -->
                                        <!-- {{ rawMetrics }} -->
                                        <div v-if="rawMetrics[parseFieldConfig(field.id).key]">
                                            <VueApexCharts
                                                :id         ="field.id"
                                                :height     ="field.height"
                                                :type       ="field.chartType === 'doughnut' ? 'donut' : field.chartType"
                                                :options    ="rawMetrics[parseFieldConfig(field.id).key].chartOptions"
                                                :series     ="rawMetrics[parseFieldConfig(field.id).key].series"
                                                width       ="100%"
                                                class       ="rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                            />
                                        </div>
                                        <div v-else>
                                            <p>Loading chart data...</p>
                                        </div>
                                    </template>

                                    <!-- Editor -->
                                    <template v-else-if="field.type === 'editor'">
                                        <Editor 
                                            editorStyle  = "height: 320px" 
                                            @load        = "({ instance }) => instance.root.setAttribute('id', field.id)"
                                            @text-change = "handleTextChange"
                                        />
                                    </template>

                                    <!-- Text Area -->
                                    <template v-else-if="field.type === 'textarea'">
                                        <textarea 
                                            :id         = "field.id"
                                            v-model     = "formData[parseFieldConfig(field.id).key]"
                                            placeholder = " " 
                                            :rows       = "field.rows" 
                                            class       = "dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"></textarea>
                                    </template>
                                                                            
                                    <!-- Map -->
                                    <template v-else-if="field.type === 'map'">
                                        <div style="height: 600px; width: 100%;position: sticky;">
                                            <l-map 
                                                :id="field.id"
                                                ref="map" 
                                                v-model:zoom="field.zoom" 
                                                :center="field.center"
                                            >
                                                <l-tile-layer
                                                    :url="field.url"
                                                    :layer-type="field.layer"
                                                    name="OpenStreetMap"
                                                ></l-tile-layer>
                                                
                                                <l-marker 
                                                    v-for="item in mapMarkers"
                                                    :lat-lng="[item.lat, item.long]"
                                                >
                                                    <!-- Icon khusus untuk setiap marker -->
                                                    <l-icon
                                                        :icon-url="field.icon"
                                                        :icon-size="[40, 40]"
                                                        :icon-anchor="[20, 20]"
                                                    />

                                                    <!-- Optional: Popup saat marker diklik -->
                                                    <!-- <LPopup v-if="item.title">
                                                    {{ item.title }}
                                                    </LPopup> -->
                                                </l-marker>
                                            </l-map>
                                        </div>
                                    </template>

                                    <!-- Table for Person -->
                                    <template v-else-if="field.type === 'tableExportPerson'">
                                        <div class="overflow-x-auto">
                                            <table class="w-full text-sm mb-4">
                                                <tbody>
                                                    <tr>
                                                        <td class="px-2 w-40 text-left font-bold">Nama Karyawan</td>
                                                        <td class="max-w-1 text-center">:</td>
                                                        <td class="px-2 py-1 text-left">{{ field.fullname }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="px-2 w-40 text-left font-bold">Periode</td>
                                                        <td class="max-w-1 text-center">:</td>
                                                        <td class="px-2 py-1 text-left">{{ field.periode }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="px-2 w-40 text-left font-bold">Total Jam Kerja</td>
                                                        <td class="max-w-1 text-center">:</td>
                                                        <td class="px-2 py-1 text-left">{{ field.totalKerja }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="px-2 w-40 text-left font-bold">Total Jam Terlambat</td>
                                                        <td class="max-w-1 text-center">:</td>
                                                        <td class="px-2 py-1 text-left">{{ field.totalTelat }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="px-2 w-40 text-left font-bold">Total Jam Lembur</td>
                                                        <td class="max-w-1 text-center">:</td>
                                                        <td class="px-2 py-1 text-left">{{ field.totalLembur }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <table border="1" class="border-collapse border border-slate-800 w-full text-sm">
                                                <thead>
                                                    <tr class="bg-slate-800 text-white">
                                                        <th class="border border-slate-700 px-3 py-2 text-center">Tanggal</th>
                                                        <th class="border border-slate-700 px-3 py-2 text-center">Jam datang</th>
                                                        <th class="border border-slate-700 px-3 py-2 text-center">Jam pulang</th>
                                                        <th class="border border-slate-700 px-3 py-2 text-center">Terlambat</th>
                                                        <th class="border border-slate-700 px-3 py-2 text-center">Lembur</th>
                                                        <th class="border border-slate-700 px-3 py-2 text-center">Keterangan</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(item, idx) in (field.reportData || [])" :key="idx" class="hover:bg-slate-700/50">
                                                        <td class="border border-slate-700 px-3 py-1.5 text-center whitespace-nowrap">{{ item.tanggal }}</td>
                                                        <td class="border border-slate-700 px-3 py-1.5 text-center">{{ item.in_time }}</td>
                                                        <td class="border border-slate-700 px-3 py-1.5 text-center">{{ item.out_time }}</td>
                                                        <td class="border border-slate-700 px-3 py-1.5 text-center">{{ item.late }}</td>
                                                        <td class="border border-slate-700 px-3 py-1.5 text-center">{{ item.overtime }}</td>
                                                        <td class="border border-slate-700 px-3 py-1.5 text-center">{{ item.notes }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <input
                                            :type       = "field.type || 'text'"
                                            :id         = "field.id"
                                            v-model     = "formData[parseFieldConfig(field.id).key]"
                                            placeholder = " "
                                            spellcheck="false"
                                            :required   = "field.required"
                                            class       = "peer w-full px-3 py-2.5 text-sm rounded border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-all"
                                        />
                                    </template>

                                    <label 
                                        :for    = "field.id"
                                        class   = "absolute text-md text-slate-500 dark:text-slate-400 duration-200 
                                                    transform scale-85 -top-3 left-2.5 z-10 origin-left px-1 
                                                    bg-white dark:bg-slate-800 
                                                    peer-placeholder-shown:scale-78 
                                                    peer-placeholder-shown:top-2.5 
                                                    peer-placeholder-shown:bg-transparent 
                                                    peer-focus:text-indigo-600 
                                                    dark:peer-focus:text-indigo-400 
                                                    peer-focus:scale-90 font-bold
                                                    peer-focus:-top-3 
                                                    peer-focus:bg-white 
                                                    dark:peer-focus:bg-slate-800 
                                                    whitespace-nowrap truncate max-w-[calc(100%-12px)]
                                                    pointer-events-none"
                                    >
                                        {{ parseFieldConfig(field.id).label }} <span v-if="field.required" class="text-rose-500">*</span>
                                    </label>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </component>

        </div>
    </template>
</div>

<DetailModal v-if   = "isModalOpen" 
    :isOpen         = "isModalOpen"
    :customColumns  = "directCustomCol"
    :formConfig     = "formConfig.layout"
    :columnDefs     = "directColumn"
    :rowData        = "selectedRowDetails" 
    :hiddenFields   = "hiddenFields.length ? hiddenFields : directHidden"
    :typeMenu       = "typeMenu"
    :columnsCustom  = "directCustomCol"
    :formatsCustom  = "directCustomFor"
    @close          = "closeModal" 
    @save           = "onRowSaved"
    @approve        = "$emit('approval_refresh')"
    @reject         = "$emit('reject_refresh')"
/>